export default __webpack_public_path__ + "static/logo-blk-f23a6ed5798471747a9a1dc144cd068f.png";